import type { Composer, ComposerTranslation } from 'vue-i18n'
import { THIRD_PERSON_SUFFIX } from '~/config/hooks/auto-translate/constants'

type TranslateParams = Parameters<ComposerTranslation>

const thirdKey = (key: string) => `${key}${THIRD_PERSON_SUFFIX}`

export default defineNuxtPlugin((nuxtApp) => {
	const getComposer = (): Composer | null => {
		const i18nInstance = nuxtApp.$i18n as Composer | { global: Composer } | undefined

		if (!i18nInstance) return null
		if ('t' in i18nInstance) {
			return i18nInstance as Composer
		}
		if ('global' in i18nInstance) {
			return (i18nInstance as { global: Composer }).global
		}
		return null
	}

	const translateThirdPerson = (key: string, params?: TranslateParams[1], context?: TranslateParams[2]) => {
		if (!key) return ''

		const composer = getComposer()
		if (!composer) return key

		const thirdKeyName = thirdKey(key)
		const result = composer.t(thirdKeyName, params, context)

		if (result === thirdKeyName) {
			return composer.t(key, params, context)
		}

		return result
	}

	return {
		provide: {
			tThird: translateThirdPerson,
		},
	}
})
